require('./ctxMessageBox.style.scss');

class CtxMessageBoxController {
    constructor($element, $scope, $timeout) {
        this.$element = $element;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.modalClass = 'modal-sm';
    }

    $postLink() {
        this.$timeout(() => {
            this.modal = this.$element.find('.modal');
            this.$scope.$watch(() => this.showModal, (show, oldShow) => {
                if (typeof show !== 'undefined') {
                    let
                        call = show ? 'onOpen' : 'onClose',
                        ret = this[call] ? this[call]() : {};
                    (ret || {}).preventDefault ? this.showModal = oldShow : this.modal.modal(show ? {show: true, backdrop: 'static', keyboard: false} : 'hide');
                }
            });
        });

    }

    $onDestroy() {
        if (this.modal) {
            this.modal.modal('hide');
        }
    }
}

const ctxMessageBoxComponent = {
    restrict: 'E',
    transclude: true,
    controller: CtxMessageBoxController,
    controllerAs: 'modalCtrl',
    template: require('./ctxMessageBox.template.html'),
    bindings: {
        showModal: '=',
        modalTitle: '<',
        modalMessage: '<',
        actionButtons: '<'
    }
};

CtxMessageBoxController.$inject = ['$element', '$scope', '$timeout'];

module.exports = ctxMessageBoxComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxMessageBox/ctxMessageBox.component.js